import React from "react";
import { styled, useTheme } from "@mui/system";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getColorIcon } from "../helper/colorIcon";
import { IconDefinition, RotateProp } from "@fortawesome/fontawesome-svg-core";
import { faIcons } from "@fortawesome/pro-regular-svg-icons/faIcons";
import { IconColor, IconSize, IconWeight } from "../VaporIcon/VaporIconType";

export interface VaporIconBaseType {
  /**
   * Color of icon
   * @default default
   */
  color?: IconColor;
  /**
   * Size of icon
   * @default 16px
   */
  size?: IconSize;
}

export interface VaporIconBaseProps extends VaporIconBaseType {
  /**
   * Fortawesome IconDefinition, if you want custom fortawesome icon
   *
   */
  icon: IconDefinition;

  /**
   * Rotate of icon
   */
  rotation?: RotateProp;
  /**
   *
   */
}
export interface VaporIconFullProps extends VaporIconBaseType {
  /**
   * Weight of icon
   * @default regular
   */
  iconWeight?: IconWeight;
  /**
   *
   */
}

export const VaporIconBase = styled(
  React.forwardRef((props: VaporIconBaseProps, ref: any) => {
    const { color, size = "16px", icon = faIcons, rotation, ...others } = props;
    const theme = useTheme();

    return (
      <FontAwesomeIcon
        ref={ref}
        style={{
          fontSize: size,
          color: color && getColorIcon(color, theme)
        }}
        icon={icon}
        rotation={rotation}
        {...others}
      />
    );
  }),
  {
    name: "VaporIconBase",
    slot: "Root",
    overridesResolver: (props, styles) => [styles.root]
  }
)(({ theme }) => ({})) as VaporIconBaseComponent;

type VaporIconBaseComponent = (
  props: VaporIconBaseProps & React.RefAttributes<HTMLDivElement>
) => JSX.Element;
